import React, { useCallback, useContext, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import SurveyQuestionsList from './survey-questions-list'
import { CurrentSociogramContext } from '@BUP/contexts/CurrentSociogramContext'
import { EnrollmentContext } from '@BUP/contexts/EnrollmentContext'
import { CourseContext } from '@BUP/contexts/CourseContext'

const SurveyData = ({ page }) => {
  const { dataCurrentSociogram } = useContext(CurrentSociogramContext)
  const enrollment = useContext(EnrollmentContext)
  const courses = useContext(CourseContext)
  const { currentSociogram } = dataCurrentSociogram
  const surveys = currentSociogram.surveys
  const enrollmentId = enrollment.id
  const course = courses[0]
  const courseTags = course.course.tags
  const courseGrade = courseTags.find(tag => tag.includes('grade'))

  const history = useHistory()

  const handleNextPage = useCallback(() => {
    history.push(`/sociogram/survey/${page + 1}`)
  }, [page, history])

  const foundSurvey = useMemo(
    () => surveys.find(survey => survey.grade === courseGrade),
    [surveys, courseGrade]
  )

  if (!foundSurvey) return <p>No survey found</p>

  return (
    <SurveyQuestionsList
      enrollmentId={enrollmentId}
      survey={foundSurvey}
      page={page}
      nextPage={handleNextPage}
    />
  )
}

export default SurveyData
